import dayjs from "dayjs";

// 登录状态
export const lineType = val => {
  return { 0: "离线", 1: "暂停", 2: "接单中" }[val];
};
//将时间戳转换为YYYY-MM-DD,*1000把十位时间戳转化为13位
export const setDate = val => {
  return val ? dayjs(val * 1000).format("YYYY-MM-DD HH:mm:ss") : "";
};
// 进店方式
export const enterType = val => {
  return { 1: "扫码进店", 2: "刷脸进店" }[val];
};
// 支付状态
export const payType = val => {
  return { 1: "未支付", 2: "已支付" }[val];
};


export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}



// WEBPACK FOOTER //
// ./src/util/filter.js